import { ImageEntity } from "@client/content/controls/Image/container";
import { type LinkType } from "@client/content/controls/Link/component";
import { RedirectLinkEntity } from "@client/content/controls/Link/Redirect/container";
import { getEntityRef } from "@client/content/lib/helper";
import { type ImageInfo } from "@client/content/types";
import HTML from "@client/controls/HTML/component";
import HTMLTag from "@client/controls/HTML/Tag/component";
import { type Tag } from "@client/types/Tag";
import * as React from "react";
import { type PortfolioGalleryItemContainerProps } from "./container";

export type PortfolioGalleryItemComponentProps = PortfolioGalleryItemContainerProps & {
  className: string;
  description: string;
  image: ImageInfo;
  titleTag: string;
  overlayStyle?: React.CSSProperties;
  preventRedirect: boolean;
  showContent: boolean;
  showTags: boolean;
  tags: Tag[];
  title: string;
  url: string;
  urlType: LinkType;
};

export default (props: PortfolioGalleryItemComponentProps) => (
  <div className={props.className}>
    <div className="portfolio_image">
      <a href={props.url}>
        <ImageEntity
          {...getEntityRef({ id: props.parentId, source: props.source })}
          src={props.image.resizedUrl}
          style={props.imageStyle}
        />
      </a>
    </div>
    {props.showContent && (
      <div className="portfolio_description">
        <HTMLTag className="title" tag={props.titleTag} html={props.title} />
        {props.showTags && !!props.tags.length && <span>{props.tags.map((t) => t.text).join(" ")}</span>}
        {!!props.description && <HTML className="description" tag="p" html={props.description} />}
      </div>
    )}

    {props.overlayStyle && <div className="overlay" style={props.overlayStyle} />}

    <RedirectLinkEntity {...getEntityRef(props)} />
  </div>
);
